__turbopack_context__.v({
  "slideDescription": "styles-module__TH45HW__slideDescription",
});
